module.exports = __webpack_public_path__ + "static/texas_pa_letter-2111f21571bb95a6b5c3e79033da2af6.jpg";